import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GlobalContext from "../../../framework/GlobalContext";
import classes from "./index.module.css";
import SelectInput from "../../../framework/SelectInput";
import TreeSelect from "../../../framework/tree-select";
import Shortcut from "../../../framework/Shortcut";
import Button from "../../../framework/Button";
import AddDiscounts from "./AddDiscounts";
import { listEntity } from "../../../services/entity-services";
import { getCategory } from "../../../services/category-services";
import { getCustomerCategories } from "../../../services/customer-category-services";
import ChipInputSelect from "../../../framework/ChipInputSelect";
import { fetchBranches } from "../../../services/branch-service";
import Checkbox from "../../../framework/Checkbox";
import { Grid } from "@mui/material";
import TextInput from "../../../framework/TextInput";
import { addDiscountProgram } from "../../../services/discount-program";
import DatePicker from "../../../framework/date/DatePicker";
import { displayToast } from "../../../framework/toast/toastUtils";
import { executeScroll } from "../../../utils/utils";
import dayjs from "dayjs";
import { getISODateTime } from "../../../utils/utils";
import { listBranchGroup } from "../../../services/branch-group-services";
const AddDiscountSlab = (props) => {
  const {
    onEscape = () => {},
    refreshData = () => {},
    currentRowData,
    isEdit = false,
  } = props;
  const [programName, setProgramName] = useState("");
  const [entity, setEntity] = useState(null);
  const [entities, setEntities] = useState([]);
  const [customerCategory, setCustomerCategory] = useState(null);
  const [customerCategories, setCustomerCategories] = useState([]);
  const [productCategory, setProductCategory] = useState(null);
  const [productCategories, setProductCategories] = useState([]);
  const [branch, setBranch] = useState([]);
  const [branches, setBranches] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [discounts, setDiscounts] = useState([
    {
      min: null,
      max: null,
      discPerMedicine: null,
    },
  ]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [errorStates, setErrorStates] = useState({});
  const programNameRef = useState(null);
  const startDateRef = useRef();
  const endDateRef = useRef();
  const entityRef = useRef();
  const customerCategoryRef = useRef();
  const productCategoryRef = useRef();
  const branchRef = useRef();
  const addDiscountsButtonRef = useRef();
  const saveDiscountsButtonRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);
  const showDeleteIcon = useMemo(() => {
    if (discounts?.length === 1) {
      return false;
    }
    return true;
  }, [discounts?.length]);
  const fetchEntityData = useCallback(async () => {
    await listEntity().then((response) => {
      setEntities(response?.result?.rows);
    });
  }, []);
  const fetchCustomerCategory = useCallback(async () => {
    await getCustomerCategories().then((response) => {
      setCustomerCategories(response?.result?.rows);
    });
  }, []);
  const fetchProductCategory = useCallback(async () => {
    await getCategory().then((response) => {
      setProductCategories(response);
    });
  }, []);
  const fetchBranchData = useCallback(async () => {
    const _branch = await fetchBranches();
    const _branchGroup = await listBranchGroup();
    const mergedBranches = [
      ...(_branchGroup?.result?.rows || []),
      ...(_branch?.result?.rows || []),
    ];
    setBranches(mergedBranches);
  }, []);
  const addDiscountsRow = useCallback(() => {
    if (discounts.length === 1) {
      if (discounts[0].min === null || discounts[0].max === null) {
        displayToast({
          type: "error",
          title: "Please enter at least one discount",
        });
        return;
      }
    }
    setDiscounts((prev) => {
      return [
        ...prev,
        {
          min: 0,
          max: 0,
          discPerMedicine: 0,
        },
      ];
    });
  }, [discounts]);
  const deleteDiscountsHandler = useCallback(
    (index) => {
      if (discounts.length <= 1) return;
      const _discounts = [...discounts];
      const filteredDiscounts = _discounts.filter((_, i) => i !== index);
      setDiscounts(filteredDiscounts);
      setTimeout(() => {
        let newIndex = index;
        if (newIndex === filteredDiscounts.length) {
          newIndex -= 1;
        }
        document
          .getElementById(`row_item_0_${newIndex}`)
          ?.focus({ preventScroll: true });
      }, 100);
    },
    [discounts]
  );
  const validateForm = useCallback(async () => {
    if (!programName) {
      displayToast({
        type: "error",
        title: "Please enter discount program name",
      });
      setErrorStates((prev) => {
        return { ...prev, programName: true };
      });
      programNameRef.current.focus({ preventScroll: true });
      setCurrentComponent("add_discount_slab_program_name");
      return false;
    }
    if (!startDate) {
      displayToast({
        type: "error",
        title: "Please select start date",
      });
      setErrorStates((prev) => {
        return { ...prev, startDate: true };
      });
      startDateRef.current.focus({ preventScroll: true });
      setCurrentComponent("add_discount_slab_start_date");
      return false;
    }
    if (!endDate) {
      displayToast({
        type: "error",
        title: "Please select end date",
      });
      setErrorStates((prev) => {
        return { ...prev, endDate: true };
      });
      endDateRef.current.focus({ preventScroll: true });
      setCurrentComponent("add_discount_slab_end_date");
      return false;
    }
    if (endDate < startDate) {
      displayToast({
        type: "error",
        title: "End date cannot be earlier than start date",
      });
      setErrorStates((prev) => {
        return { ...prev, endDate: true };
      });
      endDateRef.current.focus({ preventScroll: true });
      setCurrentComponent("add_discount_slab_end_date");
      return false;
    }
    if (!customerCategory) {
      displayToast({
        type: "error",
        title: "Please select customer category",
      });
      setErrorStates((prev) => {
        return { ...prev, customerCategory: true };
      });
      customerCategoryRef.current.focus({ preventScroll: true });
      setCurrentComponent("add_discount_slab_customer_category");
      return false;
    }
    if (!productCategory) {
      displayToast({
        type: "error",
        title: "Please select product category",
      });
      setErrorStates((prev) => {
        return { ...prev, productCategory: true };
      });
      setCurrentComponent("add_discount_slab_product_category");
      return false;
    }
    if (branch.length === 0) {
      displayToast({
        type: "error",
        title: "Please select branch",
      });
      setErrorStates((prev) => {
        return { ...prev, branch: true };
      });
      branchRef.current.focus({ preventScroll: true });
      setCurrentComponent("add_discount_slab_branch");
      return false;
    }
    if (discounts.length === 1) {
      if (discounts[0].min === null || discounts[0].max === null) {
        displayToast({
          type: "error",
          title: "Please enter at least one discount",
        });
        return;
      }
    }
    return true;
  }, [
    branch.length,
    customerCategory,
    discounts,
    endDate,
    productCategory,
    programName,
    programNameRef,
    setCurrentComponent,
    startDate,
  ]);
  const saveDiscountProgramHandler = useCallback(async () => {
    if (!(await validateForm())) {
      return;
    }
    const discountDetails = discounts.map((discount) => {
      return {
        ...discount,
        categoryId: productCategory?.value?.categoryId,
        categoryName: productCategory?.value?.categoryName,
        patientCategoryId: customerCategory?.id,
        patientCategoryName: customerCategory?.name,
        entityId: entity?.entityId,
        entityName: entity?.entityName,
        deleted: isEdit ? discount?.deleted : false,
      };
    });
    const selectedBranchIds = branches?.reduce((acc, branch) => {
      if (branch?.branchCode) {
        acc.push(...branch.branchCode);
      } else if (branch?.code) {
        acc.push(branch.code);
      }
      return acc;
    }, []);
    const branchDetails = [...new Set(selectedBranchIds)];
    const payload = {
      programName: programName,
      startDate: startDate,
      endDate: endDate,
      defaultProgram: false,
      discountProgramDetails: discountDetails,
      branchCode: branchDetails,
      discountProgramCode: isEdit
        ? currentRowData?.discountProgramCode || null
        : null,
      remarks: remarks,
    };
    await addDiscountProgram(payload).then((response) => {
      if (response?.status === "success") {
        displayToast({
          type: "success",
          title: isEdit
            ? "Discount program updated successfully."
            : "Discount program added successfully.",
        });
        onEscape();
        refreshData();
      }
    });
  }, [
    validateForm,
    discounts,
    branches,
    programName,
    startDate,
    endDate,
    isEdit,
    currentRowData?.discountProgramCode,
    remarks,
    productCategory?.value?.categoryId,
    productCategory?.value?.categoryName,
    customerCategory?.id,
    customerCategory?.name,
    entity?.entityId,
    entity?.entityName,
    onEscape,
    refreshData,
  ]);
  const keyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      const ctrlKey = event.ctrlKey;
      if (key === "escape") {
        onEscape();
        return;
      }
      if (key === "+") {
        addDiscountsButtonRef?.current?.click();
        return;
      }
      if (ctrlKey && key === "s") {
        saveDiscountsButtonRef?.current?.click();
        return;
      }
    },
    [onEscape]
  );
  const findCategoryInHierarchy = useCallback(
    (categories, categoryId, parent = null) => {
      for (const category of categories) {
        if (category.categoryId === categoryId || category.id === categoryId) {
          return {
            value: category,
            parent: parent ? { ...parent } : null,
          };
        }
        if (category.childs && category.childs.length > 0) {
          const found = findCategoryInHierarchy(category.childs, categoryId, {
            value: category,
            parent: parent ? { ...parent } : null,
          });
          if (found) {
            return found;
          }
        }
      }
      return null;
    },
    []
  );

  const initializeState = useCallback(() => {
    if (!isEdit || !currentRowData) return;
    setProgramName(currentRowData.programName || "");
    const getStartDate = dayjs(currentRowData.startDate);
    if (getStartDate.isValid()) {
      setStartDate(getStartDate);
    }
    const getEndDate = dayjs(currentRowData.endDate);
    if (getEndDate.isValid()) {
      setEndDate(getEndDate);
    }
    const entity = entities.find(
      (x) => x.entityId === currentRowData?.discountProgramDetails[0]?.entityId
    );
    setEntity(entity || null);
    const customerCategory = customerCategories.find(
      (x) =>
        x.id === currentRowData.discountProgramDetails[0]?.patientCategoryId
    );
    setCustomerCategory(customerCategory || null);
    const productCategory = findCategoryInHierarchy(
      productCategories,
      currentRowData.discountProgramDetails[0]?.categoryId
    );
    setProductCategory(productCategory || null);
    const branchCode = currentRowData.branchCode;
    const filteredBranches = branches.filter((b) =>
      branchCode.includes(b.code)
    );
    setBranch(filteredBranches || []);
    setRemarks(currentRowData?.remarks || "");
    setDiscounts(currentRowData.discountProgramDetails);
  }, [
    isEdit,
    currentRowData,
    entities,
    customerCategories,
    productCategories,
    branches,
    findCategoryInHierarchy,
  ]);

  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener]);
  useEffect(() => {
    fetchEntityData();
    fetchCustomerCategory();
    fetchProductCategory();
    fetchBranchData();
  }, [
    fetchEntityData,
    fetchCustomerCategory,
    fetchProductCategory,
    fetchBranchData,
  ]);
  useEffect(() => {
    programNameRef.current.focus({ preventScroll: true });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    initializeState();
  }, [initializeState]);

  return (
    <div id="add_discount_slab" className={classes["add-discount-slab"]}>
      <div className={classes["add-discount-slab-header"]}>
        <div className={classes["add-discount-slab-header-label"]}>
          Add Discount Program
        </div>
        <div className={classes["add-discount-slab-header-fields"]}>
          <Grid container spacing={2}>
            <Grid item xs={2.4}>
              <TextInput
                id="add_discount_slab_program_name"
                label="Discount Program Name"
                ref={programNameRef}
                value={programName}
                onChange={(e) => {
                  setProgramName(e.target.value);
                  setErrorStates((prev) => {
                    return { ...prev, programName: false };
                  });
                }}
                required={true}
                error={errorStates.programName}
                onFocus={() =>
                  setCurrentComponent("add_discount_slab_program_name")
                }
                onBlur={
                  !programName
                    ? () => {
                        setErrorStates((prev) => {
                          return { ...prev, programName: true };
                        });
                        displayToast({
                          type: "error",
                          title: "Please enter discount program name",
                        });
                      }
                    : () => {}
                }
                inputProps={{
                  "data-markers": JSON.stringify({
                    down: "add_discount_slab_product_category",
                    left: "add_discount_slab_program_name",
                    right: "add_discount_slab_start_date",
                    up: "add_discount_slab_program_name",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={2.4}>
              <DatePicker
                id="add_discount_slab_start_date"
                label="Start Date"
                inputRef={startDateRef}
                onChange={(value) => {
                  const formattedValue = getISODateTime(
                    dayjs(value).format("DD/MM/YYYY")
                  );
                  if (value && dayjs(value).isBefore(dayjs(), "day")) {
                    displayToast({
                      type: "error",
                      title: "Start date cannot be in the past",
                    });
                    setStartDate(dayjs());
                  } else {
                    setStartDate(formattedValue);
                    setErrorStates((prev) => {
                      return { ...prev, startDate: false };
                    });
                  }
                }}
                onFocus={() =>
                  setCurrentComponent("add_discount_slab_start_date")
                }
                value={startDate ? dayjs(startDate) : null}
                onBlur={
                  !startDate
                    ? () => {
                        setErrorStates((prev) => {
                          return { ...prev, startDate: true };
                        });
                        displayToast({
                          type: "error",
                          title: "Please enter start date",
                        });
                      }
                    : () => {}
                }
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_discount_slab_start_date",
                    down: "add_discount_slab_branch",
                    left: "add_discount_slab_program_name",
                    right: "add_discount_slab_end_date",
                  }),
                }}
                disablePast={true}
                required={true}
                error={errorStates.startDate}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={2.4}>
              <DatePicker
                id="add_discount_slab_end_date"
                label="End Date"
                inputRef={endDateRef}
                onChange={(value) => {
                  const formattedValue = getISODateTime(
                    dayjs(value).format("DD/MM/YYYY")
                  );
                  if (value && dayjs(value).isBefore(dayjs(), "day")) {
                    displayToast({
                      type: "error",
                      title: "End date cannot be in the past",
                    });
                    setEndDate(startDate || dayjs());
                  } else if (dayjs(value).isBefore(startDate, "day")) {
                    setEndDate(startDate || dayjs());
                  } else {
                    setEndDate(formattedValue);
                    setErrorStates((prev) => {
                      return { ...prev, endDate: false };
                    });
                  }
                }}
                onFocus={() => {
                  executeScroll(endDateRef);
                  setCurrentComponent("add_discount_slab_end_date");
                }}
                value={endDate ? dayjs(endDate) : null}
                onBlur={
                  !endDate
                    ? () => {
                        setErrorStates((prev) => {
                          return { ...prev, endDate: true };
                        });
                        displayToast({
                          type: "error",
                          title: "Please enter end date",
                        });
                      }
                    : () => {
                        if (dayjs(endDate).isSame(startDate, "day")) {
                          displayToast({
                            type: "warn",
                            title: "Start and end dates are same",
                          });
                        }
                      }
                }
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_discount_slab_end_date",
                    down: "add_discount_slab_branch",
                    left: "add_discount_slab_start_date",
                    right: "add_discount_slab_entity",
                  }),
                }}
                disablePast={true}
                required={true}
                error={errorStates.endDate}
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={2.4}>
              <SelectInput
                id="add_discount_slab_entity"
                label="Entity"
                ref={entityRef}
                disableClearable={false}
                options={entities}
                getOptionLabel={(option) => option?.entityName || option}
                isOptionEqualToValue={(option, value) => {
                  return option?.entityId === value?.entityId;
                }}
                noOptionsText="Search Family Here (e.g., Gupta)"
                name="entityName"
                onFocus={() => setCurrentComponent("add_discount_slab_entity")}
                onChange={(e, option) => {
                  setEntity(option);
                }}
                value={entity}
                onInputChange={(e) => {}}
                markers={JSON.stringify({
                  up: "add_discount_slab_entity",
                  down: "add_discount_slab_branch",
                  left: "add_discount_slab_end_date",
                  right: "add_discount_slab_customer_category",
                })}
                autoFocus
              />
            </Grid>
            <Grid item xs={2.4}>
              <SelectInput
                id="add_discount_slab_customer_category"
                label="Customer Category"
                ref={customerCategoryRef}
                options={customerCategories}
                getOptionLabel={(option) => {
                  return option.name || option;
                }}
                value={customerCategory}
                isOptionEqualToValue={(option, value) => {
                  return option?.id === value?.id;
                }}
                onFocus={() =>
                  setCurrentComponent("add_discount_slab_customer_category")
                }
                onChange={(e, option) => {
                  setErrorStates((prev) => {
                    return { ...prev, customerCategory: false };
                  });
                  setCustomerCategory(option);
                }}
                onBlur={
                  !customerCategory
                    ? () => {
                        setErrorStates((prev) => {
                          return { ...prev, customerCategory: true };
                        });
                        displayToast({
                          type: "error",
                          title: "Please enter customer category",
                        });
                      }
                    : () => {}
                }
                name="customerCategory"
                markers={JSON.stringify({
                  up: "add_discount_slab_customer_category",
                  down: "add_discount_slab_remarks",
                  left: "add_discount_slab_entity",
                  right: "add_discount_slab_product_category",
                })}
                required={true}
                error={errorStates.customerCategory}
              />
            </Grid>
            <Grid item xs={2.4}>
              <TreeSelect
                id="add_discount_slab_product_category"
                label="Product Category"
                allowMultiple={false}
                ref={productCategoryRef}
                value={productCategory}
                name="productCategory"
                onFocus={() => {
                  setCurrentComponent("add_discount_slab_product_category");
                }}
                options={productCategories}
                getOptionLabel={(option) => {
                  return option.value.categoryName || option;
                }}
                onChange={(e, newValue) => {
                  setProductCategory(newValue);
                  setErrorStates((prev) => {
                    return { ...prev, productCategory: false };
                  });
                }}
                onBlur={
                  !productCategory
                    ? () => {
                        setErrorStates((prev) => {
                          return { ...prev, productCategory: true };
                        });
                        displayToast({
                          type: "error",
                          title: "Please enter product category",
                        });
                      }
                    : () => {}
                }
                required={true}
                error={errorStates.productCategory}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_discount_slab_program_name",
                    down: "row_item_0_0",
                    left: "add_discount_slab_customer_category",
                    right: "add_discount_slab_branch",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={7.2}>
              <ChipInputSelect
                id="add_discount_slab_branch"
                value={branch || null}
                options={branches}
                groupBy={(option) =>
                  option?.code ? "Branches" : "Branch Group"
                }
                name="branch"
                ref={branchRef}
                getOptionLabel={(option) =>
                  `${option?.name || ""}- ${option?.code ? "BR" : "BG"}`
                }
                isOptionEqualToValue={(option, value) => {
                  return option === value;
                }}
                onFocus={() => {
                  setCurrentComponent("add_discount_slab_branch");
                }}
                onChange={(event, option) => {
                  setBranch(option);
                  setErrorStates((prev) => {
                    return { ...prev, branch: false };
                  });
                }}
                onBlur={
                  branch?.length === 0
                    ? () => {
                        setErrorStates((prev) => {
                          return { ...prev, branch: true };
                        });
                        displayToast({
                          type: "error",
                          title: "Please enter branch",
                        });
                      }
                    : () => {}
                }
                error={errorStates.branch}
                required={true}
                openOnFocus={true}
                label="Branches"
                multiple={true}
                blurOnSelect={false}
                disableCloseOnSelect={true}
                renderGroup={(params) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        padding: "5px",
                        gap: "5px",
                      }}
                      key={params.key}
                    >
                      <div
                        style={{
                          height: "30px",
                          width: "100%",
                          background: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          padding: "5px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                        }}
                      >
                        {params.group}
                      </div>
                      <div>{params.children}</div>
                    </div>
                  );
                }}
                renderOption={(props, option, { selected }) => {
                  return (
                    <div
                      {...props}
                      style={{
                        display: "flex",
                        height: "40px",
                        width: "100%",
                        padding: "1px 5px",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItem: "center",
                        }}
                      >
                        <Checkbox checked={selected} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItem: "center",
                          marginRight: "5px",
                        }}
                      >
                        {option?.branchGroupId ? "BG |" : "BR |"}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItem: "center",
                          gap: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: "15px",
                            width: "100%",
                          }}
                        >
                          {option?.name} (
                          {option?.code || option?.branchGroupId})
                        </div>
                      </div>
                    </div>
                  );
                }}
                markers={JSON.stringify({
                  up: "add_discount_slab_start_date",
                  down: "row_item_0_0",
                  left: "add_discount_slab_product_category",
                  right: "add_discount_slab_remarks",
                })}
              />
            </Grid>
            <Grid item xs={2.4}>
              <TextInput
                id="add_discount_slab_remarks"
                label="Remarks"
                value={remarks}
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
                onFocus={() => setCurrentComponent("add_discount_slab_remarks")}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "add_discount_slab_customer_category",
                    down: "row_item_0_0",
                    left: "add_discount_slab_branch",
                    right: "row_item_0_0",
                  }),
                }}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      <div className={classes["add-discounts-subcontainer"]}>
        <div style={{ height: "auto", maxHeight: "85%", width: "100%" }}>
          <div className={classes["add-discounts-title-container"]}>
            <div className={classes["add-discounts-title"]}>
              Add Discount Slabs
            </div>
            <Button
              label="ADD"
              color="black"
              ref={addDiscountsButtonRef}
              onClick={addDiscountsRow}
              endIcon={<Shortcut keys={["+"]} />}
            />
          </div>
          <div className={classes["add-discounts-details-container"]}>
            <div className={classes["add-discounts-details"]}>
              {discounts?.map((discount, index) => {
                return (
                  <AddDiscounts
                    key={`${index}_${discount.name}`}
                    index={index}
                    discountRowData={discount}
                    showDeleteIcon={showDeleteIcon}
                    onDeleteDiscount={() => deleteDiscountsHandler(index)}
                    onChange={(key, data) => {
                      setDiscounts((prev) => {
                        prev[index][key] = data;
                        return [...prev];
                      });
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className={classes["add-discounts-cta-container"]}>
          <Button
            label="Save"
            ref={saveDiscountsButtonRef}
            onClick={saveDiscountProgramHandler}
            color="violet"
            endIcon={<Shortcut keys={["Ctrl", "S"]} />}
          />
        </div>
      </div>
    </div>
  );
};

export default AddDiscountSlab;
